import { defineMessages } from 'react-intl';

export default defineMessages({
    ParkingTypeLabel: {
        id: 'cep.endorsement.SgVehicleForm.parkingTypeLabel',
        defaultMessage: 'Where is your car usually parked overnight?'
    },
    ParkingTypeSubLabel: {
        id: 'cep.endorsement.SgVehicleForm.parkingTypeSubLabel',
        defaultMessage: 'If your car is not kept at your home address, please call us on {phoneNumber}.'
    },
    VehicleValueLabel: {
        id: 'cep.endorsement.SgVehicleForm.VehicleValueLabel',
        defaultMessage: 'What is the value of your car?'
    },
    VehicleValueSubLabel: {
        id: 'cep.endorsement.SgVehicleForm.VehicleValueSubLabel',
        defaultMessage: 'Please enter an estimated value, based on the amount you would advertise your car for, if you were to sell it today.'
    },
    YearPurchasedLabel: {
        id: 'cep.endorsement.SgVehicleForm.YearPurchasedLabel',
        defaultMessage: 'When did you or will you buy the car?'
    },
    VehicleTrackerLabel: {
        id: 'cep.endorsement.SgVehicleForm.VehicleTrackerLabel',
        defaultMessage: 'Does your car have a tracker?'
    },
    VehicleTypeLabel: {
        id: 'cep.endorsement.SgVehicleForm.VehicleTypeLabel',
        defaultMessage: 'Select vehicle type'
    },
    VehicleOwnerTypeLabel: {
        id: 'cep.endorsement.SgVehicleForm.VehicleOwnerTypeLabel',
        defaultMessage: 'Who is the legal owner?'
    },
    ModificationQuestionSubLabel: {
        id: 'cep.endorsement.SgVehicleForm.ModificationQuestionSubLabel',
        defaultMessage: 'You do not need to include any optional extras that were fitted by the manufacturer when the car was new. '
    },
    LeaseInNameOfPhOrSpouseLabel: {
        id: 'cep.endorsement.SgVehicleForm.LeaseInNameOfPhOrSpouseLabel',
        defaultMessage: 'Is the lease in the name of the policyholder or named spouse?'
    },
});
